<template>

  <div id="app">
    <v-app id="inspire">

      <v-layout align-center justify-center>

        <m-pay-message type="error"
                       :value="$store.getters.errorMessage"
                       :trigger="$store.getters.errorMessageTrigger">
          {{ $store.getters.errorMessage }}
        </m-pay-message>

        <v-snackbar
          :value="error"
          color="error"
          :top="true"
          :multi-line="true"
          :auto-height="true"
          :timeout="6000"
          :vertical="false"
        >
          <m-pay-error-message
            :error="error"
            :login="true"
          />
          <v-btn
            dark
            flat
            @click="closeErrorMessage"
          >
            Close
          </v-btn>
        </v-snackbar>

        <v-flex xs12 sm8 md4>
          <v-card class="elevation-3 pb-3">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Login</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-form @submit.prevent="login" id="login-form">
                <v-text-field ref="usernameInput"
                              v-model="username" prepend-icon="person" name="username"
                              label="Email address" type="text" autofocus
                              data-vv-delay="500" v-validate="'required'"
                              :error-messages="errors.collect('username')"
                              autocomplete="ctdl-username">
                </v-text-field>
                <v-text-field v-model="password" prepend-icon="lock" name="password"
                              label="Password" id="password" type="password"
                              data-vv-delay="500" v-validate="'required'"
                              :error-messages="errors.collect('password')"
                              autocomplete="ctdl-password"
                              autocapitalize="off" autocorrect="off" >
                </v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions class="mr-2">
              <v-spacer></v-spacer>
              <router-link :to="{ name: 'password-recovery'}" class="pr-3">
                Forgot password?
              </router-link>
              <v-btn type="submit" color="secondary" form="login-form">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>

    </v-app>
  </div>

</template>

<script>
import MPayErrorMessage from '../MPayErrorMessage';
import MPayMessage from '../MPayMessage';

export default {
  components: { MPayErrorMessage, MPayMessage },
  data: () => ({
    username: '',
    password: '',
    error: '',
  }),
  methods: {
    login() {
      this.$validator.validateAll()
        .then((isValid) => {
          if (isValid) {
            this.error = '';
            this.clearMessages();
            const credentials = {
              username: this.username,
              password: this.password,
            };

            this.$store.dispatch('login', credentials)
              .then((error) => {
                if (error) {
                  this.error = error;
                } else {
                  this.$router.replace(this.$route.query.redirectFrom || { name: 'home' });
                }
              });
          } else {
            this.showValidationErrorMessage();
          }
        });
    },
    closeErrorMessage() {
      this.error = '';
      this.$refs.usernameInput.focus();
    },
  },
  created() {
    this.$validator.localize('en', {
      custom: {
        username: {
          required: 'Please input username',
        },
        password: {
          required: 'Please input your password',
        },
      },
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/login/MPayLogin.vue